export default {
    loading: {
        module: false
    },
    show_modal_config: false,
    paymentMethodsSend: [],
    productsPhysicalInventory: [],
    productsPhysicalInventoryBK: [],
    listBranchOfficesWarehouses: [],
    usersCount: [],
    counting_state_users: [],
    products: [],
    lines: [],
    brands: [],
    users: [],
    product_new_id: null,
    params_config: {
        branch_office_id: localStorage.selected_branchoffice,
        branch_office_warehouse_id:
            localStorage.selected_branchoffice_warehouse,
        lines: [],
        brands: [],
        users: [],
        random_num_prod: null,
        user_res_id: null,
        show_stock_counting: false,
        short_description: [],
        location: null,
        location_mode: "exacta",
        inventory_type: "general"
    },
    ag_grid: {
        selectedTheme: "ag-theme-balham"
    },
    physicalInventory: {
        id: null,
        state: null
    },
    file_name: null,
    show_pdf: false,
    shortDescriptionList: []
};



// WEBPACK FOOTER //
// ./src/modules/physical-inventory/state.js